/* PawPrint Lab homepage v2 behaviour. Idempotent: safe to load from several sections. */
(function () {
  if (window.__hv2Init) return; window.__hv2Init = true;
  var root = document.documentElement; root.classList.add('hv2-js');

  // Reveal on scroll
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items = document.querySelectorAll('.hv2-reveal');
  if (reduce || !('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-in'); }); }
  else {
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  // Sticky header state
  var header = document.querySelector('.hv2-header');
  if (header) { var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 24); }; onScroll(); window.addEventListener('scroll', onScroll, { passive: true }); }

  // Mobile nav toggle
  document.querySelectorAll('[data-hv2-nav-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () { var open = header && header.classList.toggle('is-open'); btn.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  });

  // Sticky mobile CTA: show after the hero scrolls out, hide near the closing CTA
  var sticky = document.querySelector('.hv2-sticky');
  var hero = document.querySelector('.hv2-hero');
  var closing = document.querySelector('.hv2-closing');
  if (sticky && 'IntersectionObserver' in window) {
    var heroOut = false, closingIn = false;
    var update = function () { sticky.classList.toggle('is-visible', heroOut && !closingIn); };
    if (hero) new IntersectionObserver(function (es) { es.forEach(function (e) { heroOut = !e.isIntersecting && e.boundingClientRect.top < 0; update(); }); }, { threshold: 0 }).observe(hero);
    if (closing) new IntersectionObserver(function (es) { es.forEach(function (e) { closingIn = e.isIntersecting; update(); }); }, { threshold: 0.1 }).observe(closing);
  }

  // Cart count (theme cart drawer stays untouched; we only read /cart.js)
  var count = document.querySelector('[data-hv2-cart-count]');
  if (count && window.fetch) { fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { if (c && typeof c.item_count === 'number') { count.textContent = c.item_count; count.hidden = c.item_count === 0; } }).catch(function () {}); }

  // Trustpilot TrustBox loader (only when a widget is on the page)
  if (document.querySelector('.trustpilot-widget') && !document.querySelector('script[src*="tp.widget.bootstrap"]')) {
    var s = document.createElement('script'); s.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'; s.async = true; document.head.appendChild(s);
  }

  // Video: play muted inline when visible, pause when not
  var vids = document.querySelectorAll('.hv2 video[data-hv2-autoplay]');
  if (vids.length && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (es) { es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); } }); }, { threshold: 0.25 });
    vids.forEach(function (v) { v.muted = true; vio.observe(v); });
  }
})();
